var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.885 3.237C2.205 3.868 1.75 4.893 1.75 6.5v7c0 1.607.455 2.631 1.135 3.263.69.64 1.73.987 3.115.987h10c1.385 0 2.425-.346 3.115-.987.68-.632 1.135-1.656 1.135-3.263v-7c0-1.607-.455-2.632-1.135-3.263-.69-.64-1.73-.987-3.115-.987H6c-1.385 0-2.425.346-3.115.987Zm-1.02-1.1C2.925 1.155 4.385.75 6 .75h10c1.615 0 3.075.404 4.135 1.388 1.07.994 1.615 2.469 1.615 4.362v7c0 1.893-.545 3.369-1.615 4.362-1.06.984-2.52 1.388-4.135 1.388H6c-1.615 0-3.075-.404-4.135-1.388C.795 16.87.25 15.393.25 13.5v-7c0-1.893.545-3.368 1.615-4.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.586 6.532a.75.75 0 0 1-.118 1.054l-3.13 2.5c-1.304 1.038-3.382 1.038-4.685 0H8.65l-3.12-2.5a.75.75 0 1 1 .938-1.171l3.119 2.499c.757.602 2.058.601 2.815 0l3.129-2.5a.75.75 0 0 1 1.054.118Z"
  }))));
};
export default SvgEmail;